export const zIndex = {
  base: 0,
  raised: 10,
  dropdown: 100,
  sticky: 200,
  header: 300,
  overlay: 400,
  modal: 500,
  toast: 600,
  tooltip: 700,
};
